import styled from '@emotion/styled';
import React from 'react';
import { useTranslation } from 'next-i18next';
import { TitleH2 } from 'components/Typo/TitleH2';
import { Icon } from 'components/commons/Icon';
import { theme } from 'styles/theme';
import Loc from 'components/assets/icon_localisation.svg';
import Phone from 'components/assets/Icon_phone.svg';
import Mail from 'components/assets/Icon_email.svg';
import { Text } from 'components/Typo/Text';
import { FlexBox } from 'components/commons/FlexBox';

const CustomText = styled(Text)`
  text-align: start;
`;

const Root = styled.address`
  display: grid;
  grid-row-gap: 3rem;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(3, min-content);
  flex: 1;
  font-style: normal;
  padding: 3rem;
  background-color: ${theme.colors.darkBlue};
  color: ${theme.colors.white} !important;
  & * {
    color: ${theme.colors.white} !important;
  }
  ${{
    [theme.mediaQueries.md]: {
      backgroundColor: theme.colors.lightBlueGreen,
      padding: '15rem 3rem',
      color: `${theme.colors.black} !important`,
      ' & * ': {
        color: `${theme.colors.black} !important`,
      },
    },
  }}
`;

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  justify-items: center;
  ${{
    [theme.mediaQueries.md]: {
      gridTemplateColumns: '10rem 20rem',
      justifyItems: 'unset',
    },
  }}
`;

const AddressWrapper = styled(FlexBox)`
  ${{
    [theme.mediaQueries.md]: {
      alignItems: 'flex-start',
    },
  }}
`;

const CustomTitleH2 = styled(TitleH2)`
  text-align: start;
`;

export const Address = () => {
  const { t } = useTranslation('common');
  return (
    <Root>
      <Wrapper>
        <Icon>
          <Loc />
        </Icon>
        <AddressWrapper flexDirection="column" alignItems="center">
          <CustomTitleH2>{t('mindsapp')}</CustomTitleH2>
          <CustomText>Rue Eugène-Marziano 17A,</CustomText>
          <CustomText>1227 Carouge</CustomText>
          <CustomText>Suisse</CustomText>
        </AddressWrapper>
      </Wrapper>
      <Wrapper>
        <Icon>
          <Phone />
        </Icon>
        <CustomText>
          <a href="tel:+41223013004">+41 22 301 30 04</a>
        </CustomText>
      </Wrapper>
      <Wrapper>
        <Icon>
          <Mail />
        </Icon>
        <CustomText>
          <a href="mailto:info@mindsapp.io">info@mindsapp.io</a>
        </CustomText>
      </Wrapper>
    </Root>
  );
};
